import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  factor: number;
}


import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

import { useStore } from '@store';

declare module 'vue/types/vue' {
  export interface Vue {
    ParallaxWrapper: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'ParallaxWrapper' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    factor: null
  },
  setup(__props: any) {

const props = __props as {
  factor: number;
};

/**
 * `ParallaxWrapper` component properties.
 */


const store = useStore();

const el = ref<HTMLDivElement | null>(null);
const offset = ref(0);

onMounted(() => {
  window.addEventListener('scroll', onScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll);
});

const transform = computed(() => {
  if (disabled.value) return '';

  const finalOffset = props.factor * offset.value;

  return `translateY(${finalOffset}px)`;
});

const disabled = computed(() => {
  return store.state.displayMode === 'mobile';
});

function onScroll() {
  if (disabled.value || !el.value) return;

  const winCenter = 0.5 * window.outerHeight;

  const { top, height } = el.value.getBoundingClientRect();

  const center = top + height;

  offset.value = Math.round(
    Math.min(winCenter, Math.max(-winCenter, center - winCenter)),
  );
}

return { __sfc: true,props, store, el, offset, transform, disabled, onScroll }
}

})